import axios from 'axios';

import type {
  GetApiV1TranscendHackathonRegistrationsResponse,
  GetApiV1TranscendHackathonResponse,
  PostApiV1TranscendHackathonByIdApproveResponse,
  PostApiV1TranscendHackathonByIdRejectResponse,
  PostApiV1TranscendHackathonResponse,
} from '~/api/generated';

export type Registration = GetApiV1TranscendHackathonRegistrationsResponse[number];

const BASE_PATH = '/api/v1/transcend_hackathon';

export async function fetchMyRegistration(): Promise<GetApiV1TranscendHackathonResponse> {
  const { data } = await axios.get<GetApiV1TranscendHackathonResponse>(BASE_PATH);

  return data;
}

export async function createRegistration(
  devpostUsername: string,
): Promise<PostApiV1TranscendHackathonResponse> {
  const { data } = await axios.post<PostApiV1TranscendHackathonResponse>(
    BASE_PATH,
    { devpost_username: devpostUsername },
  );

  return data;
}

export async function fetchRegistrations(): Promise<Registration[]> {
  const { data } = await axios.get<GetApiV1TranscendHackathonRegistrationsResponse>(
    `${BASE_PATH}/registrations`,
  );

  return data;
}

export async function approveRegistration(
  id: number,
): Promise<PostApiV1TranscendHackathonByIdApproveResponse> {
  const { data } = await axios.post<PostApiV1TranscendHackathonByIdApproveResponse>(
    `${BASE_PATH}/${id}/approve`,
  );

  return data;
}

export async function rejectRegistration(
  id: number,
): Promise<PostApiV1TranscendHackathonByIdRejectResponse> {
  const { data } = await axios.post<PostApiV1TranscendHackathonByIdRejectResponse>(
    `${BASE_PATH}/${id}/reject`,
  );

  return data;
}
